import Shader from './Shader';
import * as Uniform from '../Uniform';
import FRAG_IMAGE from './Fragment/image.frag';

export default class ImageShader extends Shader {
	protected textures:string[] = ["u_image"];

	public u_documentSize:Uniform.Uniform2f;
	public u_imageSize:Uniform.Uniform2f;
	public u_inputSize:Uniform.Uniform2f;
	public u_translation:Uniform.Uniform2f = new Uniform.Uniform2f(0.0, 0.0);
	public u_rotation:Uniform.Uniform1f = new Uniform.Uniform1f(0.0);
	public u_size:Uniform.Uniform2f = new Uniform.Uniform2f(1.0, 1.0);
	public u_premul:Uniform.Uniform1i = new Uniform.Uniform1i(1.0);

	public frag = ():string => FRAG_IMAGE;
}